import React, { useState } from "react";
import { MySwal } from "../../../library/swal";
import axios from "../../../library/axios";
import Button from "react-bootstrap/Button";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';

const FormScoreInternalComp = (props) => {
  // console.log(props.score)
  const [faktaAnalisis, setfaktaAnalisis] = useState(
    props.score.faktaAnalisis
  );
  const [skorPokja, setskorPokja] = useState(props.score.Skor);
  const [skorSurveyorInternal, setskorSurveyorInternal] = useState(
    props.score.skorSurveyor
  );

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleSubmitScorePokja = () => {
    // console.log(skorSurveyorInternal);
    // return false;
    if (skorSurveyorInternal === "") {
      MySwal.fire({
        icon: "error",
        title: "Oops, Error!",
        text: `Skor Surveior Internal tidak boleh kosong!`,
      });
      return false;
    }
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idKegiatanAkreditasi: props.score.idKegiatanAkreditasi,
      idBab: props.score.idBab,
      idVariable: props.score.idVariable,
      faktaAnalisis: faktaAnalisis,
      Skor: skorPokja,
      skorSurveyor: skorSurveyorInternal,
      idUser: props.score.idUser,
    };
    // console.log(requestBody)
    // return false
    axios({
      url: `/skor/update/${props.score.id}`,
      method: "PATCH",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Berhasil menyimpan Skor!",
          });

          setLoading(false);
          setDisabled(false);

          props.fetch();
          props.close();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <>
      <div className="mb-3 row">
        <label
          htmlFor="skorInternal"
          className="col-sm-12 col-form-label required"
        >
          Skor Surveior Internal
        </label>
        <div className="col-12">
          <select
            onChange={(e) => setskorSurveyorInternal(e.target.value)}
            className="form-control"
            id="skorInternal"
            value={skorSurveyorInternal}
          >
            <option value="">- Choose -</option>
            <option value="TDD">TDD</option>
            <option value="0">0</option>
            <option value="5">5</option>
            <option value="10">10</option>
          </select>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleSubmitScorePokja()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormScoreInternalComp;
